import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { useCustomParams } from "hooks/useCustomParams";

const BranchTallyUploadAttachmentFilter = ({ disabled = false }) => {
  const { params, appendParams } = useCustomParams();
  const fromDate = params.fromDate || "";
  const toDate = params.toDate || "";

  useEffect(() => {
    if (params.fromDate === undefined) appendParams({ fromDate: "", toDate: "" });
  }, [appendParams, params.fromDate]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TableFilter searchLabel="Added User" disabled={disabled} initialFilters={2}>
        <DatePicker label="From Date" value={fromDate ? moment(fromDate) : null} onChange={(value) => appendParams({ fromDate: value ? value.format("YYYY-MM-DD") : "" })} renderInput={(props) => <TextField {...props} size="small" fullWidth />} format="MM/DD/YYYY" maxDate={toDate ? moment(toDate) : moment()} disableFuture />
        <DatePicker label="To Date" value={toDate ? moment(toDate) : null} onChange={(value) => appendParams({ toDate: value ? value.format("YYYY-MM-DD") : "" })} renderInput={(props) => <TextField {...props} size="small" fullWidth />} format="MM/DD/YYYY" minDate={fromDate ? moment(fromDate) : undefined} maxDate={moment()} disableFuture />
      </TableFilter>
    </LocalizationProvider>
  );
};

export default BranchTallyUploadAttachmentFilter;
